import { render, staticRenderFns } from "./temperature.vue?vue&type=template&id=0cad43f7&scoped=true&"
import script from "./temperature.vue?vue&type=script&lang=js&"
export * from "./temperature.vue?vue&type=script&lang=js&"
import style0 from "./temperature.vue?vue&type=style&index=0&id=0cad43f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad43f7",
  null
  
)

export default component.exports